import { render, staticRenderFns } from "./Mortality.vue?vue&type=template&id=16f43066&scoped=true&"
import script from "./Mortality.vue?vue&type=script&lang=js&"
export * from "./Mortality.vue?vue&type=script&lang=js&"
import style0 from "./Mortality.vue?vue&type=style&index=0&id=16f43066&lang=scss&scoped=true&"
import style1 from "./Mortality.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f43066",
  null
  
)

export default component.exports